<template>
  <div class="wrapper" v-if="currentBotData.length > 0">

    <Background/>

    <div class="content">

      <Nav :fixed="false" :bottomNav="true">
        <template v-slot:logo-box>
          <Logo scaleMode="playMode"/>
        </template>
        <template v-slot:options-box>
          <DialoguesButton scaleMode="playMode"/>
          <TitleInput :title="getTitle" @onChange="onTitleChange"/>
          <SaveButton @onSave="onSave" ref="saveButton"/>
        </template>
        <template v-slot:play-modes-box>
          <PlayModesButtonsEditor mode="create" @onPlayMode="onPlayMode"/>
        </template>
        <template v-slot:account-box>
          <AccountButton/>
        </template>
        <template v-slot:bottom-bar-box>
          <TitleInput :title="getTitle" :mobile="true" @onChange="onTitleChange"/>
        </template>
      </Nav>

      <div class="main">
        <div :class="{'bot-box': true, 'marginTop': path.length == 0}">
          <div class="back-arrow" title="Previous" v-if="path.length > 0" @click="goBack">
            <font-awesome-icon icon="arrow-left" class="icon"/>
          </div>
          <Bot v-for="bot in currentBotData" :botData="bot" :key="bot.id"/>
        </div>
        <div class="answer-box">
          <Answer v-for="(answer, index) in currentAnswers" :index="index" :saved="answer" :key="answer.id"/>
          <CreateAnswer v-if="currentAnswers.length < 4"/>
        </div>
        <div class="person">
          <img :src="getPerson">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import alert from '@/lib/alert'
import swal from 'sweetalert'
import axios from 'axios'
import Bot from '../components/Create/Bot'
import Answer from '../components/Create/Answer'
import CreateAnswer from '../components/Create/CreateAnswer'
import { mapActions, mapGetters } from 'vuex'
import Background from '../components/Create/Background'

//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import DialoguesButton from '@/components/Nav/DialoguesButton'
import PlayModesButtonsEditor from '@/components/Nav/PlayModesButtonsEditor'
import AccountButton from '@/components/Nav/AccountButton'
import SaveButton from '@/components/Nav/SaveButton'
import TitleInput from '@/components/Nav/TitleInput'

import person_1 from '../assets/persons/p_1.png'
import person_2 from '../assets/persons/p_2.png'
import person_3 from '../assets/persons/p_3.png'
import person_4 from '../assets/persons/p_4.png'
import person_5 from '../assets/persons/p_5.png'
import person_6 from '../assets/persons/p_6.png'
import person_7 from '../assets/persons/p_7.png'
import person_8 from '../assets/persons/p_8.png'
import person_9 from '../assets/persons/p_9.png'
import person_10 from '../assets/persons/p_10.png'
import person_11 from '../assets/persons/p_11.png'
import person_12 from '../assets/persons/p_12.png'
import person_13 from '../assets/persons/p_13.png'
import person_14 from '../assets/persons/p_14.png'
import person_15 from '../assets/persons/p_15.png'
import person_16 from '../assets/persons/p_16.png'
import person_17 from '../assets/persons/p_17.png'
import person_18 from '../assets/persons/p_18.png'
import person_19 from '../assets/persons/p_19.png'
import person_20 from '../assets/persons/p_20.png'
import person_21 from '../assets/persons/p_21.png'
import person_22 from '../assets/persons/p_22.png'
import person_23 from '../assets/persons/p_23.png'
import person_24 from '../assets/persons/p_24.png'
import person_25 from '../assets/persons/p_25.png'

export default {
  name: 'Create',
  data() {
    return {
      title: '',
      autoSaveTimeout: null,
      previewLoad: false,
      homeLoad: false,
      person_1,
      person_2,
      person_3,
      person_4,
      person_5,
      person_6,
      person_7,
      person_8,
      person_9,
      person_10,
      person_11,
      person_12,
      person_13,
      person_14,
      person_15,
      person_16,
      person_17,
      person_18,
      person_19,
      person_20,
      person_21,
      person_22,
      person_23,
      person_24,
      person_25,
    }
  },
  components: {
    Bot,
    Answer,
    CreateAnswer,
    Background,
    //Nav
    Nav,
    Logo,
    DialoguesButton,
    PlayModesButtonsEditor,
    AccountButton,
    SaveButton,
    TitleInput
  },
  methods: {
    ...mapActions('create', ['clearState', 'addFirstBot', 'pathBack', 'save', 'changeTitle']),
    ...mapActions('player', ['playerStop']),
    ...mapActions('tutorials', ['openTutorial']),
    createNewBot() {
      this.addFirstBot();
    },
    addNewAnswer() {
      this.addAnswer();
    },
    goBack() {
      this.playerStop();
      this.pathBack();
    },
    exit() {
      this.homeLoad = true;
      this.playerStop();
      this.save().then(() => {
        this.homeLoad = false;
        this.$router.push('/main');
      });
      clearTimeout(this.autoSaveTimeout);
    },
    loadPreview() {
      this.previewLoad = true;
      this.playerStop();
      this.save().then(() => {
        this.previewLoad = false;
        this.$router.push(`/preview?id=${this.getShortId}`);
      });
      clearTimeout(this.autoSaveTimeout);
    },
    autoSave() {
      if(this.$router.currentRoute.name == 'Create') {
        console.log('----AUTOSAVE----');
        clearTimeout(this.autoSaveTimeout);
        this.save();
        this.autoSaveTimeout = setTimeout(this.autoSave, 30000);
      } else {
        clearTimeout(this.autoSaveTimeout);
        console.log('----AUTOSAVE DELETED----');
      }
    },
    onClearTimeout() {
      clearTimeout(this.autoSaveTimeout);
    },
    onPlayMode(mode) {
      this.playerStop();
      this.onClearTimeout();
      this.save().then(() => {
        this.$router.push(`/${mode}?exercise_id=${this.getId}`);
      });
    },
    onSave() {
      this.playerStop();
      this.onClearTimeout();
      this.save().then(() => {
        this.$refs.saveButton.saved();
        // swal({
        //   title: "Exercise Saved",
        //   text: " ",
        //   icon: "success",
        //   button: false,
        //   timer: 1500,
        // });
      }).catch(err => {
        this.$refs.saveButton.saved();
        if(err == 'tooLarge') {
          swal("Too large!", "Reduce the exercise size to save it!", "error");
        }
      })
    },
    onTitleChange(value) {
      this.changeTitle(value);
    }
  },
  mounted() {
    this.playerStop();
    clearTimeout(this.autoSaveTimeout);
    this.autoSaveTimeout = setTimeout(this.autoSave, 30000);
    this.clearState();
    this.createNewBot();

    if(!localStorage.getItem('FirstCreate')) {
      setTimeout(() => {
        this.openTutorial({ questionIndex: '1', localStorage: 'FirstCreate' });
      }, 1000);
    }
  },
  computed: {
    ...mapGetters('create', ['currentBotData', 'currentAnswers', 'path', 'getTitle', 'checkSaving', 'getShortId', 'getCurrentBotPerson', 'getPersonStore', 'getId']),
    getPerson() {
      if(this.getCurrentBotPerson.type != null) {
        if(this.getCurrentBotPerson.type == 'stock') {
          switch(this.getCurrentBotPerson.data) {
            case 1: return this.person_1;
            case 2: return this.person_2;
            case 3: return this.person_3;
            case 4: return this.person_4;
            case 5: return this.person_5;
            case 6: return this.person_6;
            case 7: return this.person_7;
            case 8: return this.person_8;
            case 9: return this.person_9;
            case 10: return this.person_10;
            case 11: return this.person_11;
            case 12: return this.person_12;
            case 13: return this.person_13;
            case 14: return this.person_14;
            case 15: return this.person_15;
            case 16: return this.person_16;
            case 17: return this.person_17;
            case 18: return this.person_18;
            case 19: return this.person_19;
            case 20: return this.person_20;
            case 21: return this.person_21;
            case 22: return this.person_22;
            case 23: return this.person_23;
            case 24: return this.person_24;
            case 25: return this.person_25;
            default: return '';
          }
        }else if(this.getCurrentBotPerson.type == 'upload') {
          let result = this.getPersonStore.find(object => {
            return object.name == this.getCurrentBotPerson.data;
          })
          return `${result.data}`;
        }else {
          return '';
        }
      } else {
        return '';
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_SERVER_URL}limitDialogs`,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') 
      },
    }).then(() => {
      next();
    }).catch(() => {
      console.log('Limit Error');
      alert.showError('Dialog limit reached');
      next('/main');
    })
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  height: auto;
  background-color: rgb(62, 64, 70);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
}

.content {
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  height: auto;
}

nav {
  width: 75vw;
  height: 5rem;
  display: flex;
  flex-direction: row;
  @media (min-width: 1600px) {
    width: 80rem;
  }
  @media (max-width: 1400px) {
    width: 80vw;
  }
  @media (max-width: 1250px) {
    width: 85vw;
  }
  @media (max-width: 1150px) {
    width: 90vw;
  }
  @media (max-width: 1050px) {
    width: 95vw;
  }
  @media (max-width: 1000px) {
    display: flex;
  }
  @media (max-width: 800px) {
    height: 7rem;
    flex-direction: column;
  }
  @media (max-width: 600px) {
    height: 7rem;
    flex-direction: column;
  }

  .left {
    display: flex;
    width: auto;
    height: auto;
    flex-direction: row;
    @media (max-width: 800px) {
      margin-top: 0.5rem;
    }
  }

  .right {
    display: flex;
    width: auto;
    height: auto;
    margin-left: auto;
    flex-direction: row;
    @media (max-width: 800px) {
      margin-top: 0.5rem;
      margin-left: unset;
    }
  }

  .back {
    width: 5rem;
    height: 5rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    color: white;
    font-size: 2.5rem;
    transition: 0.2s;
    @media (max-width: 800px) {
      height: 3rem;
      width: 3rem;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
    }
    &:hover {
      cursor: pointer;
      color: rgb(199, 199, 199);
    }
    &:active {
      transform: scale(0.9);
    }
  }

  .exercise-title {
    width: 20rem;
    height: 5rem;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    @media (max-width: 800px) {
      height: 3rem;
      align-items: center;
      width: 100%;
    }

    input {
      width: 20rem;
      height: 2.5rem;
      background-color: rgb(71, 73, 80);
      border: 1px solid rgb(47, 48, 53);
      outline: none;
      border-radius: 0.2rem;
      color: rgb(146, 146, 155);
      font-size: 1rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      @media (max-width: 800px) {
        width: 100%;
      }
    }
  }

  .save-box {
    height: 2.6rem;
    width: 2.5rem;
    margin-right: 2rem;
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 800px) {
      display: none;
    }

    .icon  {
      color: white;
      font-size: 1.5rem;
      animation: 1.2s rotate ease-in-out infinite;
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  .preview {
    height: 5rem;
    width: 7rem;
    margin-right: 2rem;
    display: flex;
    align-items: flex-end;
    @media (max-width: 800px) {
      height: 2.5rem;
      flex: 1;
      margin-right: unset;
    }

    .preview-button {
      width: 7rem;
      height: 2.5rem;
      background-color: rgb(106, 216, 224);
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.3rem;
      border-radius: 0.2rem;
      transition: 0.2s;
      @media (max-width: 800px) {
        display: none;
      }

      &:hover {
        background-color: rgb(94, 187, 194);
        cursor: pointer;
      }
      &:active {
        transform: scale(0.9);
      }
    }

    .preview-button-mobile {
      width: 98%;
      height: 2.5rem;
      background-color: rgb(106, 216, 224);
      color: white;
      display: none;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
      border-radius: 0.2rem;
      transition: 0.2s;
      @media (max-width: 800px) {
        display: flex;
      }

      &:hover {
        background-color: rgb(94, 187, 194);
        cursor: pointer;
      }
      &:active {
        transform: scale(0.9);
      }
    }
  }

  .quit {
    height: 5rem;
    width: 6rem;
    display: flex;
    align-items: flex-end;
    @media (max-width: 800px) {
      height: 2.5rem;
      width: unset;
      flex: 1;
    }

    .quit-button {
      width: 8rem;
      height: 2.5rem;
      background-color: rgb(66, 208, 131);
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
      border-radius: 0.2rem;
      transition: 0.2s;
      @media (max-width: 800px) {
        display: none;
      }

      &:hover {
        background-color: rgb(57, 182, 113);
        cursor: pointer;
      }
      &:active {
        transform: scale(0.9);
      }
    }

    .quit-button-mobile {
      width: 98%;
      height: 2.5rem;
      background-color: rgb(66, 208, 131);
      color: white;
      display: none;
      justify-content: center;
      align-items: center;
      font-size: 1.3rem;
      border-radius: 0.2rem;
      transition: 0.2s;
      @media (max-width: 800px) {
        display: flex;
      }

      &:hover {
        background-color: rgb(57, 182, 113);
        cursor: pointer;
      }
      &:active {
        transform: scale(0.9);
      }
    }
  }
}

.main {
  width: 75vw;
  flex: auto;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (min-width: 1600px) {
    width: 80rem;
  }
  @media (max-width: 1400px) {
    width: 80vw;
  }
  @media (max-width: 1250px) {
    width: 85vw;
  }
  @media (max-width: 1150px) {
    width: 90vw;
  }
  @media (max-width: 1050px) {
    width: 95vw;
  }
  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.bot-box {
  margin-top: 1.5rem;
  width: auto;
  height: auto;
  z-index: 2;
  @media (max-width: 1000px) {
    margin-top: 2rem;
    margin-bottom: 5vh;
    width: 80%;
  }
  @media (max-width: 800px) {
    margin-top: 2rem;
    margin-bottom: 1rem;
    width: 80%;
  }
  @media (max-width: 600px) {
    margin-top: 2rem;
    margin-bottom: 1rem;
    width: 100%;
  }

  .back-arrow {
    width: 2.5rem;
    height: 2.5rem;
    margin-bottom: 1.5rem;
    background-color: #11b6a5;
    border-radius: 0.5rem;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;

    @media (max-width: 600px) {
      margin-left: 0.5rem;
    }

    &:hover {
      cursor: pointer;
    }
  }
}

.marginTop {
  margin-top: 4rem;
}

.answer-box {
  z-index: 2;
  width: 29rem;
  min-height: 20rem;
  height: auto;
  padding-top: 4rem;
  padding-bottom: 2rem;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  @media (max-width: 1000px) {
    width: 80%;
    position: initial;
    margin-top: auto;
    margin-bottom: 1rem;
  }
  @media (max-width: 600px) {
    width: 100%;
    position: initial;
    margin-top: auto;
    margin-bottom: 1rem;
  }
}

.create-answer {
  width: 100%;
  height: 5rem;
  border: 2px dashed rgb(37, 38, 41);
  border-radius: 0.5rem;
  color: rgb(37, 38, 41);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;
  user-select: none;

  .icon {
    font-size: 1.5rem;
  }

  span {
    font-size: 1.4rem;
    margin-left: 1rem;
  }

  &:hover {
    -webkit-box-shadow: inset 0px 0px 20px -5px rgb(37, 38, 41);
    -moz-box-shadow: inset 0px 0px 20px -5px rgb(37, 38, 41);
    box-shadow: inset 0px 0px 20px -5px rgb(37, 38, 41);
    cursor: pointer;
  }

  &:active {
    -webkit-box-shadow: 0px 0px 20px 3px rgba(33,35,39,1);
    -moz-box-shadow: 0px 0px 20px 3px rgba(33,35,39,1);
    box-shadow: inset 0px 0px 20px 3px rgb(37, 38, 41);
  }
}

.person {
  position: absolute;
  bottom: 0rem;
  left: 0rem;
  width: 30rem;
  @media (max-width: 1000px) {
    width: 100%;
    height: 50vh;
    display: flex;
    justify-content: center;
  }

  img {
    position: absolute;
    max-height: 55vh;
    width: auto;
    max-width: 100%;
    bottom: 0;
  }
}
</style>